RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Configurations = Backbone.Collection.extend({
        model: App.models.Configuration,
        url: function () {
            const me = this;
            return `/api/landscapes/${me.landscapeId}/configurations/${me.curation}`;
        }
    });
});
